<template>
  <el-dialog custom-class="predict-result-container dialog-size-large"
             title="評価結果"
             visible="true"
             append-to-body="true"
             :top="0"
             :modal="false"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="predict-result-container-inner">
      <fixed-header-table class="predict-result-overview" :fixed="true">
        <tr slot="header">
          <th>評価データ</th>
          <th>モデル名</th>
          <th style="flex-grow: 0; min-width: 120px;">評価日</th>
          <th style="flex-grow: 0; min-width: 120px;">件数</th>
        </tr>
        <tr>
          <td>{{uploadFileName}}</td>
          <td>{{modelName}}</td>
          <td style="flex-grow: 0; min-width: 120px;">{{predictEvaluation.updatedAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD')}}
          </td>
          <td style="flex-grow: 0; min-width: 120px;">{{predictEvaluation.count | number_format}}</td>
        </tr>
      </fixed-header-table>

      <h3 style="margin-top: 16px; flex-shrink: 0;">性能</h3>
      <fixed-header-table :fixed="true">
        <tr slot="header">
          <th v-for="evaluation in modelEvaluations" style="min-width: 160px; flex:1;">{{evaluation.nameJa || evaluation.name}}
            <tooltip-icon class="evaluation-tip" v-if="evaluation.description && evaluation.description.text"
                          :content="evaluation.description.text"></tooltip-icon>
          </th>
        </tr>
        <tr>
          <td v-for="evaluation in modelEvaluations" style="min-width: 160px; flex:1;">
            <span v-if="predictEvaluation.evaluations.hasOwnProperty(evaluation.name)">{{Number(predictEvaluation.evaluations[evaluation.name]).toFixed(4)}}</span>
            <span v-else>-</span>
          </td>
        </tr>
      </fixed-header-table>
    </div>
  </el-dialog>
</template>

<script>
import EvaluationsCmp from '../../evaluations.vue'
import { PredictEvaluationResult, PredictEvaluationValue } from '../../../../defines/model/model'

export default {
  name: 'PredictEvaluationResultDialog',
  components: {
    'evaluations-container': EvaluationsCmp
  },
  props: {
    modelName: '',
    uploadFileName: '',
    predictEvaluationResult: PredictEvaluationResult
  },
  data () {
    return {
      modelEvaluations: [],
      predictEvaluation: PredictEvaluationValue
    }
  },
  created () {
    this.modelEvaluations = this.predictEvaluationResult.modelEvaluations
    this.predictEvaluation = this.predictEvaluationResult.predictEvaluation
  }
}

</script>

<style scoped>
  .predict-result-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .predict-result-container-inner .table-wrapper.fixed {
    border-bottom: none;
    border-right: none;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .predict-result-container-inner .table-wrapper.fixed >>> .table-header > thead,
  .predict-result-container-inner .table-wrapper.fixed >>> .table-header > thead {
    padding-right: 0;
  }

  .predict-result-container-inner .table-wrapper.fixed >>> .table-body {
    overflow-y: hidden;
  }

  .evaluation-tip {
    margin-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/predict-evaluation/dialogs/predict-evaluation-result.vue